export default "__VITE_ASSET__DlXLqppb__"